module.exports = __webpack_public_path__ + "static/media/icon-reliable.92fbbf93.jpg";